<template>
    <el-select v-bind="$attrs" v-on="$listeners" placeholder="" :multiple="multiple" :clearable="clearable" :filterable="filterable" collapse-tags :value="parsedValue" @input="change">
        <template slot="prefix">
            <slot name="prefix"></slot>
        </template>

        <template v-if="groupValue">
            <el-option-group v-for="group in parsedOptions" :key="group.label" :label="group.label">
                <el-option v-for="(item, index) in group.options" :key="index" :value="item[keyValue]" :label="getLabel(item)" :title="getLabel(item)">
                    <slot :props="item"></slot>
                </el-option>
            </el-option-group>
        </template>
        <template v-else>
            <template v-if="casoTooltip">
                <el-tooltip v-for="(item, index) in parsedOptions" placement="top" effect="light" :open-delay=500>
                    <div slot="content">Refnum: {{item.refnum}} <br/>
                                {{$t('createCase.issue')}}: {{item.asunto}} <br/>
                                {{$t('createCase.state')}}: {{item.idestadodesc}} <br/>
                                {{$t('createCase.priority')}}: {{item.idprioridaddesc}} <br/>
                                {{$t('createCase.workflow')}}: {{item.idworkflowdesc}} <br/>
                                {{$t('createCase.stages')}}: {{item.idstageactualdesc}} <br/>
                                {{$t('createCase.product')}}: {{item.idproductodesc}} <br/>
                                {{$t('createCase.reason')}}: {{item.idtipodesc}} <br/>
                                {{$t('createCase.subtype')}}: {{item.idsubtipodesc}} <br/>
                                {{$t('createCase.account')}}: {{item.idcuentadesc}} <br/></div>
                    <el-option :key="index" :value="item[keyValue]" :label="getLabel(item)" >
                        <slot :props="item"></slot>
                    </el-option>
                </el-tooltip>
            </template>
            <template v-else-if="ignoreNull">
                <template v-for="(item, index) in parsedOptions">
                    <el-option v-if="item[keyValue] != null && item[keyValue] != 0" :key="index" :value="item[keyValue]" :label="getLabel(item)" :title="getLabel(item)">
                    <slot :props="item"></slot>
                    </el-option>
                </template>
            </template>
            <template v-else>
                <el-option v-for="(item, index) in parsedOptions" :key="index" :value="item[keyValue]" :label="getLabel(item)" :title="getLabel(item)">
                    <slot :props="item"></slot>
                </el-option>
            </template>
        </template>
    </el-select>
</template>

<style lang="scss">
    .el-select {
        @apply w-full;
    }

    .el-cascader-menu {
        width: 300px!important;
        right: 0px!important;
    }

    .el-select-dropdown.el-popper {
       width: 300px!important;
       right: 12px!important;
   }

    @media screen and (max-width: 329px) {
        .el-select-dropdown.el-popper {
            width: 87%!important;
            left: 14px !important;
            right: auto!important
        }
    }
</style>

<script>
import map from 'lodash/map'
import pick from 'lodash/pick'
import values from 'lodash/values'
import groupBy from 'lodash/groupBy'
import castArray from 'lodash/castArray'

export default {
  props: {
    value: {},
    keyValue: {
      type: String,
      required: true
    },
    labelValue: {
      type: [String, Array],
      required: true
    },
    groupValue: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    separador: {
      type: String,
      default: ' '
    },
    casoTooltip: {
      type: Boolean,
      required: false,
      default: false
    },
    ignoreNull: {
      type: Boolean,
      required: false,
      default: false
    },
    labelTranslate: null
  },
  computed: {
    parsedValue () {
      return this.multiple ? this.value ? castArray(this.value) : [] : this.value
    },
    parsedOptions () {
      return this.groupValue ? map(groupBy(this.options, this.groupValue), (options, label) => ({ options, label })) : this.options
    }
  },
  methods: {
    getLabel (item) {
      return this.labelTranslate ? this.$t(item.value) : values(pick(item, castArray(this.labelValue))).join(this.separador)
    },
    change (value) {
      this.$emit('input', value)
    }
  }
}
</script>
